import { IContacts } from 'CommonTypes/Tasks/QuickAddTaskForm/IResponse';

export default (contacts: IContacts[], defaultContactId: number) => {
    const defaultContact = contacts.find(contact => contact.id === +defaultContactId);

    return defaultContact ?? null;
};
